// A tab still running an older web build may ask for a hashed chunk that a deploy has since retired (the webroot keeps
// the previous releases' chunks for 14 days: infra/caddy/publish-static.sh). Vite reports that as `vite:preloadError`;
// instead of an error screen the page reloads once onto the current build. A second failure within a minute is left
// to the route error page, so a real outage never turns into a reload loop. The desktop app serves its own bundle.
const KEY = 'moods:stale-chunk-reload';
const WINDOW_MS = 60_000;

export function installStaleChunkReload(win: Window = window, now: () => number = Date.now): void {
  win.addEventListener('vite:preloadError', event => {
    let last = 0;
    try {
      last = Number(win.sessionStorage.getItem(KEY) ?? 0);
    } catch {
      // storage blocked: still reload once per page load
    }
    if (now() - last < WINDOW_MS) return;
    try {
      win.sessionStorage.setItem(KEY, String(now()));
    } catch {
      // ignore
    }
    event.preventDefault();
    win.location.reload();
  });
}
